/**
 * lead-sql — Lead Intelligence Report (Sales Qualified).
 *
 * A template folder is self-describing: this file is the ONLY thing the
 * registry imports. conf declares the non-code parameters; the API wires the
 * schema contract to the renderer. Design in localhost, see it in the Report
 * Studio instantly, commit to publish.
 */
import { SQL_TEMPLATE, SQL_REVISION, validateSqlReport, translationTexts, validateTranslations, type SqlReport, type Translations } from '../../schema/lead';
import { renderSqlReport } from './render';

export const conf = {
  id: SQL_TEMPLATE,
  name: 'Lead SQL',
  description: 'Lead intelligence, activity timeline and the final interaction summary.',
  revision: SQL_REVISION,
  sourceKinds: ['lead'] as const,
  pdfBucket: 'lead-reports' as const,
  /** Admin → Reports: this template's sections/sheets are configurable. */
  sectionConfig: true,
  /** Prose is AI-translated on demand (no local dictionary). */
  i18n: 'ai' as const,
};

/** The registry-facing template API. `render` defaults to the full SQL document;
 *  MQL renders through the same renderer with `mql:true` (no activity/summary sheets). */
export const reportTemplate = {
  conf,
  validate: validateSqlReport,
  translationTexts: (d: SqlReport): Translations => translationTexts(d),
  validateTranslations: (d: SqlReport, t: unknown) => validateTranslations(d, t),
  render: renderSqlReport,
};
